import { apiGet } from '../../api'

export const get_all_greenlight_surveys = query => {
  return apiGet({
    endpoint: `greenlight/all_surveys`
  })
}
